import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

declare var cordova:any;

@Component({
  selector: 'page-print_code',
  templateUrl: 'page.html'
})
export class PrintCodePage {

  code:any={text:''};

  constructor(
    public navCtrl: NavController,
    public barcodeScanner:BarcodeScanner,

  ) {

  }

  print(){
    let codeCanvas = document.querySelectorAll('canvas');
    console.log(codeCanvas[0]);
    let code = codeCanvas[0];
    let img = code.toDataURL("image/jpeg");
    img = img.substr(23);
    let me = this;
    cordova.plugins.brotherPrinter.findBluetoothPrinters(function(printers){
        cordova.plugins.brotherPrinter.setPrinter(printers[0], function(){
          cordova.plugins.brotherPrinter.printViaSDK(img,function(statusCode){
          },function(err){
          });
        },function(err) {
          console.log(err);
        });
    },function(err){
        console.log(err)
    });
  }

  createCode(){
    this.barcodeScanner.encode('TEXT_TYPE',this.code).then(resp => {
      console.log(resp);
     }).catch(err => {
         console.log('Error', err);
     });
  }
  
  scan(){
    this.barcodeScanner.scan().then(barcodeData => {
      console.log('Barcode data', barcodeData);
      this.code = barcodeData;
     }).catch(err => {
         console.log('Error', err);
     });
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/print_code/page.ts